/**
 * TASK-391 §3.6 — pure visibility logic for the user-location dot.
 *
 * The dot is a placeholder marker drawn on the map at the station
 * nearest to the user. It is hidden when the user is outside the UK, or
 * farther than {@link DOT_THRESHOLD_METERS} from that nearest station.
 *
 * Rendering / visual design is refined separately after implementation
 * (spec §7 out-of-scope); this module only owns the show/hide rule.
 */

/**
 * Maximum distance (meters) from the nearest station at which the dot
 * is still shown. Starts at ~2 km per the spec — tune later.
 */
export const DOT_THRESHOLD_METERS = 2_000

export interface UserLocationDotVisibilityArgs {
  /** Whether the user's raw coordinate is inside the UK bounding box. */
  readonly insideUK: boolean
  /** Distance from the user to the nearest station, in meters. */
  readonly distanceMeters: number
}

/**
 * `true` when the user-location dot should be drawn — inside the UK and
 * within {@link DOT_THRESHOLD_METERS} of the nearest station.
 */
export function isUserLocationDotVisible(args: UserLocationDotVisibilityArgs): boolean {
  return args.insideUK && args.distanceMeters <= DOT_THRESHOLD_METERS
}
